<template>
  <div
    class="sidebar-logo-container"
    :class="{ collapse: collapse }"
    :style="{
      backgroundColor:
        sideTheme === 'theme-dark'
          ? variables.menuBackground
          : variables.menuLightBackground,
    }"
  >
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="">
        <img v-if="logo" :src="logo" class="sidebar-logo" />
        <h1
          style="text-align: left"
          v-else
          class="sidebar-title"
          :style="{
            color:
              sideTheme === 'theme-dark'
                ? variables.logoTitleColor
                : variables.logoLightTitleColor,
          }"
        >
          {{ title }}
        </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="">
        <img v-if="logo" :src="logo" class="sidebar-logo" />
        <h1
               style="text-align: left"
          class="sidebar-title"
          :style="{
            color:
              sideTheme === 'theme-dark'
                ? variables.logoTitleColor
                : variables.logoLightTitleColor,
          }"
        >
          {{ title }}
        </h1>
      </router-link>
    </transition>
  </div>
</template>

<script setup>
import variables from "@/modules/huyu-framework/backend/assets/styles/variables.module.scss";
// import logo from "@/modules/huyu-framework/backend/assets/logo/logo.jpg";
import useSettingsStore from "@/store/modules/settings";
import useDeviceStore from "@/store/modules/device";
import { onMounted } from "vue";
defineProps({
  collapse: {
    type: Boolean,
    required: true,
  },
});

const title = ref(useDeviceStore().pageTitle);
const settingsStore = useSettingsStore();
const sideTheme = computed(() => settingsStore.sideTheme);
let logo = ref("@/modules/huyu-framework/backend/assets/logo/logo.jpg");
// watchEffect(() => {
//   if (useDeviceStore().pageTitle) {
//     console.log("变化了");
//     title.value = useDeviceStore().pageTitle;
//   }
// });

onMounted(() => {
  let project = localStorage.getItem("projects");
  let projectId = localStorage.getItem("projectId");
  project = JSON.parse(project);

  project.find((item) => {
    if (item.projectId == projectId) {
      title.value = item.projectName;
      logo.value = import.meta.env.VITE_APP_BASE_API + item.projectLogo;
    }
  });
});
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex !important;
    align-items: center;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin: 0 12px;
    }

    & .sidebar-title {
      color: rgb(255, 255, 255);
      width: 66%;
      height: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;

      // display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
